import { render, staticRenderFns } from "./navMenuItem.vue?vue&type=template&id=b3e7ed4c&functional=true&"
import script from "./navMenuItem.vue?vue&type=script&lang=js&"
export * from "./navMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/nav/items/navMenuItem.vue"
export default component.exports